import { render, staticRenderFns } from "./MultiScroller.vue?vue&type=template&id=98316726&scoped=true"
import script from "./MultiScroller.vue?vue&type=script&lang=js"
export * from "./MultiScroller.vue?vue&type=script&lang=js"
import style0 from "./MultiScroller.vue?vue&type=style&index=0&id=98316726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98316726",
  null
  
)

export default component.exports